import React, { useEffect, useState } from 'react';
import getCarParkDistance from '../../../../global/helpers/getDistanceFomGeoPoints';

const SearchResultCell = (props) => {
  const previousSiblings = (elem) => {
    // create an empty array
    let siblings = [];

    // loop through previous siblings until `null`
    while ((elem = elem.previousElementSibling)) {
      // push sibling to array
      siblings.push(elem);
    }
    return siblings;
  };

  useEffect(() => {
    if (props.activeClass) {
      const $container = document.querySelector(
        '.simpleLocationSearchResultReact'
      );
      const $element = document.querySelector(
        `.searchResultCell.${props.activeClass}`
      );
      const $sort = $container.querySelector('.d-flex');
      const $previous = previousSiblings($element);
      const offsetY = $previous.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.offsetHeight + 8;
      }, $sort.offsetHeight + 16);
      $container.scroll(0, offsetY);
    }
  }, [props.activeClass]);

  const getParkingUrl = () => {
    if (
      $('body').hasClass('en-NZ') &&
      props.monthlyParkingServiceIsAvailable &&
      props.cpms
    ) {
      return props.cpms.replace('{0}', props.cpmsCarparkCode || '');
    }
    return props.url;
  };

//   const isElevateOnly = props.carParkFeature.includes('Elevate Only');
  const isElevateOnly = () => {
	const prepayCarParkFeature = window.prepayCarParkFeature; // E.g: 'Epark,Elevate Only,Prepay Online'
	if (!props.carParkFeature || !prepayCarParkFeature || props.carParkFeature.length === 0) return;
	const prepayFeaturesArray = prepayCarParkFeature.split(',');
	return prepayFeaturesArray.every((feature) => props.carParkFeature.includes(feature));
  };

  const handleOpenPrepayModal = (event) => {
    event.preventDefault();
    const prepayModal = document.getElementById('prepayModal');
    if (prepayModal) {
      if (prepayModal.classList.contains('hidden')) {
        prepayModal.classList.remove('hidden');
      }
    }
  };

  return (
    <div
      className={`searchResultCell border rounded p-3 bg-white mb-2 pointer position-relative ${props.activeClass} ${props.highlightClass}`}
      onClick={() => props.callbackClick()}
    >
      <div className='d-flex align-items-center'>
        <a href={`${props.url}${location.search}`} className='font-weight-bold'>
          {props.name}
        </a>
        <div className='d-flex flex-1 justify-content-end align-items-center'>
          {/* <div className="fsp-12 mr-1">From</div> */}
          {/* {props.rates[0] && <div className="font-weight-bold">${props.rates[0].rates[0].price}</div>} */}
          {props.fromText && (
            <div className='fsp-12 mr-1'>{props.fromText}</div>
          )}
          {props.fromPrice && (
            <div className='font-weight-bold'>${props.fromPrice}</div>
          )}
        </div>
      </div>
      {props.location && props.location.address && (
        <div className='fsp-14 tag-feature'>{props.location.address}</div>
      )}
      <div className='fsp-14'>{`${props.distance.toFixed(2)} km`}</div>
      <div className='d-flex align-items-center'>
        {/* <a href="/parking-locations/victoria/south-yarratoorak/jam-factory-car-park/? */}
        <a href={`${props.url}${location.search}`} className='flex-1 fsp-14'>
          View details
        </a>
        <div className='flex-1'></div>

        {/* if it is Find a park page */}
        {props.carParkFeature.includes('Book a Bay') &&
          props.type === 'findapark' && (
            <a
              href={isElevateOnly() ? 'javscript:void(0)' : props.bookabayUrl}
              target={props.ctatarget}
              className='btn btn-outline-primary pointer fsp-14'
              onClick={(e) => isElevateOnly() && handleOpenPrepayModal(e)}
            >
              {props.ctaText && props.ctaText.length > 0
                ? props.ctaText
                : 'Book now'}
            </a>
          )}

        {/* if it is monthly parking page */}
        {/* collapse7 is the get a quote id */}
        {props.type && props.type === 'monthly' && (
          <a
            target={props.ctatarget || '_blank'}
            href={`${getParkingUrl()}`}
            className='btn btn-outline-primary pointer fsp-14'
          >
            {props.ctaText && props.ctaText.length > 0
              ? props.ctaText
              : 'Get a quote'}
          </a>
        )}

        {/* {props.carParkFeature.includes("Book a Bay") && (
					<a href={props.bookabayUrl} className="btn btn-outline-primary pointer fsp-14">
						Book now
					</a>
				)} */}
        {/* if it is bookonline parking page */}
        {props.carParkFeature.includes('Book a Bay') &&
          props.type &&
          props.type === 'bookonline' && (
            <a
              onClick={(e) => {
                if (isElevateOnly()) {
                  handleOpenPrepayModal(e);
                } else {
                  props.setBookOnlinePark(props.name);
                  props.setBookOnlineState(
                    props.location.region.state.abbreviation
                  );
                  props.setCarParkCode(props.carParkNumber);
                }
              }}
              href={
                isElevateOnly()
                  ? 'javscript:void(0)'
                  : '#simpleLocationSearchContainer'
              }
              className='btn btn-outline-primary pointer fsp-14'
            >
              {props.ctaText && props.ctaText.length > 0
                ? props.ctaText
                : 'Book online'}
            </a>
          )}
      </div>
      <div
        className={`checktag ${props.activeClass} text-center rounded-circle icon-check text-white`}
      ></div>
    </div>
  );
};

/**
 *
 * @param {func} applySort
 * @param {array} sort
 */

const SimpleLocationSearchResult = (props) => {
  const [toggleSort, setToggleSort] = useState(false);

  const handleActiveCarPark = (parkingItem) => {
    props.handleActiveCarPark(parkingItem);
    props.setMapData({
      center: {
        lat: parkingItem.location.latitude,
        lng: parkingItem.location.longitude,
      },
      distance: props.mapData.distance,
    });
  };

  const augmentDistance = () => {
    return props.carParks.map((carPark) => {
      const distance = getCarParkDistance(
        carPark.location.latitude,
        carPark.location.longitude,
        props.destination.lat,
        props.destination.lng
      );
      return {carPark, distance};
    });
  };

  const renderSort = (sort) => {
    return (
      <div className='sort-wrapper'>
        {sort.map((el, i) => (
          <div
            data-field={el.key}
            key={i}
            className={`field py-2 ${el.selected == true ? 'active' : ''}`}
            onClick={() => {
              props.applySort(el.key);
            }}
          >
            {el.name}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className='simpleLocationSearchResultReact p-3'>
      <div className='d-flex'>
        <div className='fsp-14 mb-2 overview flex-1'>
          Showing {props.carParks && props.carParks.length} results in the area
        </div>
        <div
          className={`font-weight-bold pointer position-relative ${
            props.sort == null ? 'd-none' : ''
          }`}
          onClick={() => setToggleSort(!toggleSort)}
        >
          <div className={toggleSort ? `active` : ``}>
            <span>Sort</span>
            <span
              className={
                toggleSort
                  ? `icon-chevron-up ml-2 text-torch-red`
                  : `icon-chevron-down ml-2 text-torch-red`
              }
            ></span>
          </div>
          {toggleSort && renderSort(props.sort)}
        </div>
      </div>
      <div className='simpleLocationSearchResultReact-list'>
        {augmentDistance().map((augmentedParkingItem) => (
          <SearchResultCell
            key={augmentedParkingItem.carPark.name}
            {...augmentedParkingItem.carPark}
            callbackClick={() =>
              handleActiveCarPark(augmentedParkingItem.carPark)
            }
            highlightClass={
              augmentedParkingItem.carPark.featuredIndex &&
              augmentedParkingItem.carPark.featuredIndex > 0
                ? 'carpark-feature'
                : ''
            }
            activeClass={
              augmentedParkingItem.carPark === props.activeCarPark
                ? 'isSelected'
                : ''
            }
            bookabayUrl={props.formatBookUrl(
              augmentedParkingItem.carPark.carParkNumber
            )}
            destination={props.destination}
            distance={augmentedParkingItem.distance}
            ctaText={props.ctaText}
            ctatarget={props.ctatarget}
            type={props.type}
            recenter={props.setMapData}
            cpms={props.cpms}
            // book operation
            setBookOnlinePark={props.setBookOnlinePark}
            setBookOnlineState={props.setBookOnlineState}
            setCarParkCode={props.setCarParkCode}
          />
        ))}
      </div>
    </div>
  );
};

export default SimpleLocationSearchResult;
